var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import AlertTitle from '../../atoms/AlertTitle';
import settingsDictionary from '../../../strings/settingsDictionary';
import { FAL_ANGLE_DOWN } from '../../../const/iconProps';
import { AlertHeaderDeliveryIcon, AlertHeaderIconsWrapper, AlertHeaderLeft, AlertHeaderPanelIndicator, AlertHeaderRight, AlertHeaderSeparator, AlertHeaderStatus, AlertHeaderWrapper } from './subcomponents';
var deliveryIcons = settingsDictionary.deliveryIcons, deliveryIconsSolid = settingsDictionary.deliveryIconsSolid;
var AlertHeader = function (_a) {
    var _b;
    var isAccordionExpanded = _a.isAccordionExpanded, currentAlertData = _a.currentAlertData, showDeliveryIcons = _a.showDeliveryIcons;
    var t = useTranslation().t;
    var isAlertOn = currentAlertData.isAlertOn, alertId = currentAlertData.id, categoryId = currentAlertData.categoryId, currentDeliveryMethods = currentAlertData.allDeliveryMethods;
    var currentInputValue = (_b = currentAlertData === null || currentAlertData === void 0 ? void 0 : currentAlertData.attributes[0]) === null || _b === void 0 ? void 0 : _b.value;
    var dataEnrollAnalytics = isAlertOn ? 'on' : 'off';
    var alertOnText = t('helperText.onStatus');
    var alertOffText = t('helperText.offStatus');
    var dataSubfunction = alertId.toLocaleLowerCase().replace(/_/g, ' ');
    var dataAttributes = isAccordionExpanded
        ? {
            function: categoryId,
            subfunction: dataSubfunction,
            name: 'start',
            enroll: dataEnrollAnalytics,
            type: 'expand',
            arrowRotation: 180
        }
        : {
            function: '',
            subfunction: '',
            name: '',
            enroll: '',
            type: 'collapse',
            arrowRotation: 0
        };
    return (_jsxs(AlertHeaderWrapper, __assign({ "data-test": "alerts-header-wrapper", "data-function": dataAttributes.function, "data-subfunction": dataAttributes.subfunction, "data-name": dataAttributes.name, "data-enroll": dataAttributes.enroll, "data-reason": dataSubfunction, "data-type": dataAttributes.type, className: "ensightenalertevent" }, { children: [_jsx(AlertHeaderLeft, __assign({ "data-test": "AlertHeaderLeft" }, { children: _jsx(AlertTitle, { "data-test": "AlertTitle", alertID: alertId, inputValue: isAlertOn ? currentInputValue : '' }) })), _jsxs(AlertHeaderRight, __assign({ "data-test": "AlertHeaderRight" }, { children: [_jsx(AlertHeaderIconsWrapper, __assign({ "data-test": "AlertHeaderIconsWrapper", showIcon: showDeliveryIcons }, { children: currentDeliveryMethods.map(function (deliveryMethod) {
                            var label = deliveryMethod.key, enrolled = deliveryMethod.enrolled;
                            var icon = (enrolled ? deliveryIconsSolid[label] : deliveryIcons[label]);
                            return (_jsx(AlertHeaderDeliveryIcon, __assign({ "data-test": "AlertHeaderDeliveryIcon", label: label, enrolled: enrolled }, { children: _jsx(FontAwesomeIcon, { "aria-hidden": false, "aria-label": enrolled ? t("deliveryIconsTitle.".concat(label)) : '', icon: icon }) }), label));
                        }) })), _jsx(AlertHeaderSeparator, __assign({ "data-test": "AlertHeaderSeparator", showSeparator: showDeliveryIcons }, { children: "\u00A0" })), _jsx(AlertHeaderStatus, __assign({ "data-test": "AlertHeaderStatus", isAlertOn: isAlertOn, showStatus: showDeliveryIcons }, { children: isAlertOn ? alertOnText : alertOffText })), _jsx(AlertHeaderPanelIndicator, __assign({ "data-test": "AlertHeaderPanelIndicator" }, { children: _jsx(FontAwesomeIcon, { icon: FAL_ANGLE_DOWN, size: "lg", transform: { rotate: dataAttributes.arrowRotation } }) }))] }))] })));
};
export default AlertHeader;
